import $ from 'jquery';
(function(){
  'use strict';

  $(window).ready(function(){

    // Initialise the accordions on the page
    $('.js-page-accordion').accordion({
      'useCSSTransitions': true,
      'selector': '.js-page-accordion'
    });
  });

}());

/**
 * Collapsible accordions.
 *
 * Expected mark-up:
 * <div class="accordion"> // Optional class: 'is-active'
  <h1-6>Click here to expand/collapse accordion</h1-6>
  <elem>This is the content to show/hide</elem>
 * </div>
 *
 * Basic usage:
 * $('.accordion').accordion();
 *
 * Options:
 * 'autoScroll' Boolean. Default: true. Enable or disable the 'auto scroll' function that scrolls the browser window back to the top of an open accordion if it expands above the top of the viewport. Disabling this may resolve competing scroll actions (User Vs jQuery) on mobile devices.
 * 'buttonSelector' CSS selector. Default: '.js-btn-accordion'. The selector 'hook' for the accordion functionality. Only change this if you are having conflicts.
 * 'containerSelector' CSS selector. Default: none. The selector to use as the accordion group container. If not specified, then one is automatically created and added by the plugin.
 * 'multiselectable' Boolean. Default: false. Sets how many accordions can be open at one time. By default, the accordion group can only have one accordion open at a time.
 * 'selector' String. Default: Blank. This should be the same selector as you called the plugin on. E.g. '.accordion'.
 * 'scrollingOffset' Integer. Default: '30'. An additional amount of pixels to offset when the window needs to scroll to the top of the activated accordion.
 * 'targetContent' CSS selector. Default: none. Manually specify an element to be used as the accordion content. Note: If this is used then both the trigger and the content elements receive the 'is-active' class.
 * 'useCSSTransitions' Boolean. Default: false. Specify whether the plugin should use CSS transitions to animate the accordion content. Note: This plugin does not contain browser feature detection - the developer should add a check in their main JS before enabling this option.
 *
 * @author jchalmers@squiz.net
 */
(function ($) {

  $.fn.accordion = function(options) {

    var settings = $.extend({
      'autoScroll': true,
      'buttonSelector': '.js-btn-accordion',
      'containerSelector': '',
      'multiselectable': false,
      'scrollingOffset': 30,
      'targetContent': '',
      'useCSSTransitions': false,
      'selector': ''
    }, options );

    var $this = {},
      sAccordionContentHeight = '',
      nAccordionTopOffset = 0,
      nViewportTopOffset = 0,
      iAnimMaxDuration = 1200, // The maximum duration of an accordion animation.
      iAnimMinDuration = 200, // The minimum duration of an animation that is at minimum height.
      iMinHeight = 80, // Used for animation calculations. Does not place a limit on accordion height.
      nMinHeightRatio = 0,
      iAnimDuration = 0,
      sNamespace = "accordion",
      sHelperSelector = "u-accordion-helper",
      $contentElement = {},
      s_CSSTransition = '',
      s_CSSTransitionMaxHeight = '3000px',
      a_TotalAccordionsArray = [],
      i_CurrentAccordionIndex = 0,
      b_IsCSSMode = false,
      b_IsManualMode = false,
      // sAccordionSelector = '',
      s_KeyPressSelector = '';

    $this = $( settings.selector );
    // sAccordionSelector = settings.selector.split('.')[1];

    // Check for CSS transition mode.
    if ( settings.useCSSTransitions ) {
      b_IsCSSMode = true;
    }

    // Set the accordion trigger button and content area.
    // Check to see if the target content has been specifically defined.
    if ( settings.targetContent !== '' ) {

      // Accordion has been manually defined.
      b_IsManualMode = true;
      createManualAccordionMarkup();
    } else {

      // Standard accordion.
      // Configure the accordion as per the expected markup.
      createAccordionMarkup();
      setUpAccordionGroups();
    }

    // Check for any 'open by default' accordions.
    showActiveDefault();

    // Respond to clicks on the accordion label.
    $(settings.selector + ' ' + settings.buttonSelector).on( 'click', function( evt ) {

      $this = $(this);
      $this.blur();

      /**
       * If the target has a HREF attribute, assume that it's a
       * normal link being clicked (ignore the accordion functionality).
       */
      if (
        $( evt.target ).attr( 'href' ) !== undefined &&
        $( evt.target ).attr( 'href' ) !== '' &&
        $( evt.target ).attr( 'href' ) !== '#'
        ) {

        return;
      }

      // Disable the accordion functionality if there are no siblings to show/hide
      // and if the content has not been manually defined.
      if (  !b_IsManualMode &&
          $this.next().length === 0 ) {

        return;
      }

      evt.preventDefault();
      updateAccordion();
    });

    if ( b_IsManualMode ) {

      s_KeyPressSelector = settings.selector;
    } else {

      s_KeyPressSelector = settings.selector + ' > ' + settings.buttonSelector;
    }

    // Respond to key presses on the accordion label.
    $(s_KeyPressSelector).keydown( function(evt) {

      // If the target is a BUTTON element, then the 'click' handler already provides this functionality.
      if ( $(evt.target).is('button') === false ) {

        // SPACE and ENTER key presses.
        if ( evt.which === 13 || evt.which === 32 ) {

          $(this).trigger( 'click' );
        }
      }

      // Only respond to the following keys if the target is NOT a manually defined accordion and if accordion 'multiselectable' groups are enabled.
      if ( !b_IsManualMode && settings.multiselectable === false ) {

        a_TotalAccordionsArray = $(this).parent().parent().children().children(settings.buttonSelector);
        i_CurrentAccordionIndex = $(this).parent().index();

        // UP arrow and LEFT arrow key presses.
        if ( evt.which === 38 || evt.which === 37 ) {

          // Select the previous accordion label (or loop to the end) and update the tab indexes and ARIA states.

          // First check for sibling accordions.
          if ( a_TotalAccordionsArray.length > 1 ) {

            $(this).attr({
              'tabindex': '-1',
              'aria-selected': 'false'
            });

            if ( (i_CurrentAccordionIndex - 1) < 0 ) {

              $( a_TotalAccordionsArray[ a_TotalAccordionsArray.length - 1 ] )
                .attr({'tabindex': '0', 'aria-selected': 'true'})
                .focus();
            } else {

              $( a_TotalAccordionsArray[ i_CurrentAccordionIndex - 1 ] )
                .attr({'tabindex': '0', 'aria-selected': 'true'})
                .focus();
            }
          }
        }

        // DOWN arrow and RIGHT arrow key presses.
        if ( evt.which === 40 || evt.which === 39 ) {

          // Select the next accordion label (or loop to the begining) and update the tab indexes and ARIA states.

          // First check for sibling accordions.
          if ( a_TotalAccordionsArray.length > 1 ) {

            $(this).attr({
              'tabindex': '-1',
              'aria-selected': 'false'
            });

            if ( (i_CurrentAccordionIndex + 1) === a_TotalAccordionsArray.length ) {

              $( a_TotalAccordionsArray[ 0 ] )
                .attr({'tabindex': '0', 'aria-selected': 'true'})
                .focus();
            } else {

              $( a_TotalAccordionsArray[ i_CurrentAccordionIndex + 1 ] )
                .attr({'tabindex': '0', 'aria-selected': 'true'})
                .focus();
            }
          }
        }
      }

    });

    // If using CSS transitions, then listen for the CSS 'transition end' event on the accordion content.
    if ( b_IsCSSMode ) {

      if ( b_IsManualMode ) {

        // Manually defined accordions.
        $(settings.targetContent).parent().on( 'transitionend', onCSSTransitionComplete );
      } else {

        // Standard accordions.
        $(settings.selector + ' .' + sHelperSelector).on( 'transitionend', onCSSTransitionComplete );
      }
    }

    // Setup complete.
    onInitComplete();

    /**
     * Accordion button has been manually defined.
     * Update the accordion settings and add the appropriate attributes to the button.
     */
    function createManualAccordionMarkup() {

      // Use the manually defined accordion elements.
      settings.buttonSelector = '';

      // Add attributes.
      $this.attr({
            'tabindex': '0'
          });

      if ( $this.is('button') === false) {

        $this.attr({
            'role': 'button'
          });
      }

      createUtilityMarkup(settings.targetContent);
    }

    /*
     * Wraps headers and content within the accordion and adds appropriate classes.
     */
    function createAccordionMarkup() {

      var group = {},
        additionalClasses = '',
        additionalAttributes = '',
        $AccordionTitle = {};

      // Iterate over each accordion
      $this.each(function() {

        $(this).attr( 'role', 'presentation' );

        // Apply the label class to the first <h1-6> or <span> child tag and treat it as the accordion label/button
        $AccordionTitle = $(this).children('h1, h2, h3, h4, h5, h6, span, button').eq(0);
        $AccordionTitle
          .addClass( sNamespace + '__label js-btn-accordion ' + additionalClasses )
          .attr({
            'role': 'tab',
            'id': ( 'tab' + getRandomInt().toString() ),
            'aria-selected': 'false',
            'aria-expanded': 'false',
            'tabindex': '-1'
          });

        // Treat remaining children as content and wrap them in a new DIV
        $AccordionTitle
          .nextAll()
          .wrapAll( '<div class="' + sNamespace + '__content"></div>' );

        additionalClasses = '';
      });

      // Wraps all adjacent accordions in a container (for grouping)
      for ( var i = 0, len = $this.length; i < len; i++ ) {

        group =
          $this
            .eq(i)
            .add(
              $this
                .eq(i)
                .nextUntil( ':not(.' + sNamespace + ')' )
              );

        // Groups of 1 accordion should never be 'multiselectable'.
        if ( group.length === 1 ) {

          additionalAttributes = 'false';
        } else {

          additionalAttributes = 'true';
        }

        if ( settings.containerSelector !== '') {

          // Use a manually specified element as the accordion container.
          $(settings.containerSelector)
            .addClass( sNamespace + '__container' )
            .attr({
              'role': 'tablist',
              'aria-multiselectable': additionalAttributes
            });
        } else {

          // Create a new DIV to wrap the accordion(s) in.
          group.wrapAll( '<div class="' + sNamespace + '__container" role="tablist" aria-multiselectable="' + additionalAttributes + '"></div>' );
        }

        i = i + group.length - 1;
      }

      createUtilityMarkup();
    }

    /**
     * Wrap all accordion contents in a DIV with the required utility classes.
     *
     * @param {String} elementSelector Optional. Specify an element to wrap in the utility classes.
     */
    function createUtilityMarkup(elementSelector) {

      var additionalClasses = '',
        s_TabID = '';

      if ( b_IsCSSMode ) {

        additionalClasses = 'u-css-transition';
      }

      // Check if an element selector has been provided (typically a manual accordion).
      if ( elementSelector !== '' && elementSelector !== undefined ) {

        // Generate a unique ID.
        s_TabID = 'accordion' + getRandomInt().toString();

        // Wrap the accordion content.
        $(elementSelector).wrap( '<div id="' + s_TabID + '" class="' + sHelperSelector + ' ' + sNamespace + '__content-container ' + additionalClasses + '" aria-hidden="true">' );

        // Set the ARIA attibutes on the accordion button.
        $this.attr({
          'aria-controls': s_TabID,
          'aria-expanded': 'false'
        });

      } else {

        // Iterate over each accordion.
        $this.each(function() {

          s_TabID = $(this).children('.js-btn-accordion').attr('id');

          $(this)
            .children( '.' + sNamespace + '__content' )
            .wrap( '<div class="' + sHelperSelector + ' ' + additionalClasses + '" role="tabpanel" aria-labelledby="' + s_TabID + '" aria-hidden="true">' );
        });
      }

    }

    /**
     * Create and add the unique accordion group IDs to the accordion buttons that have the same parent DIV.
     */
    function setUpAccordionGroups() {

      if ( settings.multiselectable ) {

        // Accordion 'multiselectable' groups are enabled.

        // Set all accordion labels as the DOM tabbing target.
        $this.parent().each(function() {

          $(this)
            .children()
            .children( settings.buttonSelector )
            .attr( 'tabindex', '0' );
        });

        return;
      }

      $this.parent().each(function() {

        $(this).attr( 'aria-multiselectable', 'false' );

        // If no active accordion has been set, then set the first accordion in the group as the DOM tabbing target.
        if ( $(this).children().hasClass( 'is-active' ) === false ) {

          $(this)
            .children()
            .children( settings.buttonSelector )
            .eq(0)
            .attr( 'tabindex', '0' );
        }

        $(this)
          .children()
          .children( settings.buttonSelector )
          .attr( 'data-group-id', 'group-' + getRandomInt().toString() );
      });
    }

    /**
     * Updates a collapsible accordion item.
     * Check the update type and delegate as necessary.
     */
    function updateAccordion() {

      // Reset the accordion group (if it exists anywhere on the page).
      $(settings.buttonSelector)
        .not($this)
        .each( function() {

        if (
          $(this).attr( 'data-group-id' ) !== undefined &&
          $(this).attr( 'data-group-id' ) !== '' &&
          $(this).attr( 'data-group-id' ) === $this.attr( 'data-group-id' ) &&
          $(this).hasClass( 'is-active' )
          ) {

          // Hide content of every other group member.
          hideContent( $(this) );
        }
      });

      // Check if the accordion is currently open.
      if ( $this.hasClass( 'is-active' ) ) {

        // Accordion is currently open - hide the accordion content.
        hideContent( $this );
      } else {

        // Accordion is currently closed - show the accordion content.
        showContent();
      }
    }

    /**
     * Hide the accordion's content.
     */
    function hideContent($accordionButton) {

      // Get the content height.
      // First check to see if the content has been specifically defined.
      if ( b_IsManualMode ) {

        $contentElement = $(settings.targetContent).parent();
      } else {

        $contentElement = $accordionButton.next();
      }

      // Calculate the content height.
      sAccordionContentHeight = Math.ceil( $contentElement.outerHeight(true) );

      // Calculate a consistent animation duration.
      nMinHeightRatio = sAccordionContentHeight / iMinHeight;
      iAnimDuration = parseInt( ( iAnimMinDuration / ( iMinHeight / nMinHeightRatio ) ), 10 ) + iAnimMinDuration;

      if ( iAnimDuration > iAnimMaxDuration) {
        iAnimDuration = iAnimMaxDuration;
      }

      if ( b_IsCSSMode ) {

        // Use CSS transitions to hide content.

        s_CSSTransition = 'max-height ' + iAnimDuration.toString() + 'ms 0ms ease, visibility 0ms ' + iAnimDuration.toString() + 'ms ease';

        $contentElement
          .css({
            '-webkit-transition': s_CSSTransition,
            '-moz-transition': s_CSSTransition,
            'transition': s_CSSTransition,
            'visibility': '',
            'max-height': ''
          })
          .attr( 'aria-hidden', 'true' );

        // Remove the active state from the accordion label and content.
        if ( b_IsManualMode ) {

          // Manually defined accordion.
          $this
            .removeClass( 'is-active' )
            .attr( 'aria-expanded', 'false' );

          $contentElement.removeClass( 'is-active' );
        } else {

          // Standard accordion.
          $contentElement
            .prev()
            .removeClass( 'is-active' )
            .attr({
              'aria-expanded': 'false',
              'aria-selected': 'false'
            });
        }
      } else {

        // Use jQuery animate to hide content.

        // Remove the inline CSS, animate the 'height' and padding properties, and remove the 'is-active' class.
        $contentElement
          .stop()
          .animate( {
            'height' : '0px',
            'visibility': 'hidden'
          }, iAnimDuration, function() {

            // Update the accordion label and content classes and attributes.
            if ( b_IsManualMode ) {

              // Manually defined accordion.
              // Label.
              $this
                .removeClass( 'is-active' )
                .attr( 'aria-expanded', 'false' );

              // Content.
              $(this)
                .removeClass( 'is-active' )
                .attr( 'aria-hidden', 'true' );
            } else {

              // Standard accordion.
              // Label.
              $(this)
                .prev()
                .removeClass( 'is-active' )
                .attr({
                  'aria-expanded': 'false',
                  'aria-selected': 'false'
                });

              // Content.
              $(this).attr( 'aria-hidden', 'true' );
            }

            // Clear inline styling.
            $(this).css( 'height', '' );
          });
      }
    }

    /**
     * Show the accordion's content.
     */
    function showContent() {

      // First check to see if the content has been specifically defined.
      if ( b_IsManualMode ) {

        // Get the content target and set it's state as 'active'.
        $contentElement = $(settings.targetContent).parent();
        $contentElement.addClass( 'is-active' );

        // Set the active state and ARIA attributes on the accordion label.
        $this
          .addClass( 'is-active' )
          .attr({
            'aria-expanded': 'true'
          });
      } else {

        // Get the content target.
        $contentElement = $this.next();

        // Need to update all other accordions in the group to lose their DOM tabbing target if the group is not 'multiselectable'.
        if ( !settings.multiselectable ) {

          $this
            .parent()
            .parent()
            .children()
            .children( settings.buttonSelector )
            .attr( 'tabindex', '-1' );
        }

        // Set the active state and ARIA attributes on the accordion label.
        $this
          .addClass( 'is-active' )
          .attr({
            'aria-expanded': 'true',
            'aria-selected': 'true',
            'tabindex': '0'
          });
      }

      // Set the ARIA attributes on the accordion content.
      $contentElement.attr( 'aria-hidden', 'false' );

      // Calculate the content height.
      sAccordionContentHeight = Math.ceil( $contentElement.children().eq(0).outerHeight(true) );

      // Calculate a consistent animation duration.
      nMinHeightRatio = sAccordionContentHeight / iMinHeight;
      iAnimDuration = parseInt( ( iAnimMinDuration / ( iMinHeight / nMinHeightRatio ) ) * nMinHeightRatio, 10 ) + iAnimMinDuration;

      if ( iAnimDuration > iAnimMaxDuration) {
        iAnimDuration = iAnimMaxDuration;
      }

      if ( b_IsCSSMode ) {

        // Use CSS transitions to reveal content.

        s_CSSTransition = 'max-height ' + iAnimDuration.toString() + 'ms ease';

        $contentElement.css({
          '-webkit-transition': s_CSSTransition,
          '-moz-transition': s_CSSTransition,
          'transition': s_CSSTransition,
          'visibility': 'visible',
          'max-height': sAccordionContentHeight
        });

      } else {

        // Use jQuery animate to reveal content.

        // Remove the inline CSS, animate the 'height' and padding properties, and add the 'is-active' class.
        $contentElement
          .stop()
          .css( {
            'height': '0',
            'visibility': 'visible'
          } )
          .animate( {
            'height' : sAccordionContentHeight,
          }, iAnimDuration, function() {

            // Reset inline styling
            $(this).css( {
              'height': 'auto',
              'overflow': 'visible'
            } );

            animateToOffset();
          });
      }
    }

    /**
     * Handle CSS transition end events on the accordion content.
     *
     * @param {jQuery Event} transitionEvent Transition end event from jQuery
     */
    function onCSSTransitionComplete(transitionEvent) {

      if (
        $( transitionEvent.target ).prev().hasClass('is-active') ||
        $( transitionEvent.target ).hasClass('is-active') ) {

        // Accordion was opened. Set the 'open state' properties.
        $(this).css({
          'max-height': s_CSSTransitionMaxHeight,
          '-webkit-transition': '',
          '-moz-transition': '',
          'transition': ''
        });

        animateToOffset();
      } else {

        // Accordion was closed. Set the 'closed state' properties.
        $(this).css({
          '-webkit-transition': '',
          '-moz-transition': '',
          'transition': ''
        });
      }
    }

    /**
     * If the expanded accordion content has pushed the accordion label past the top of the viewport then scroll the viewport back up to the accordion label.
     */
    function animateToOffset() {

      // Skip this fuction if autoscrolling is disabled.
      if ( !settings.autoScroll ) {
        return;
      }

      nAccordionTopOffset = $this.offset().top;
      nViewportTopOffset = $(window).scrollTop();

      if ( nAccordionTopOffset - nViewportTopOffset < 0 ) {

        $( 'html, body' ).animate({ scrollTop: nAccordionTopOffset - settings.scrollingOffset });
      }
    }

    /**
     * If an accordion has been set to be visible by default (i.e; has the 'is-active' class), then make sure it's content is visible.
     */
    function showActiveDefault() {

      if ( b_IsManualMode ) {

        // Accordion is manually defined.
        if ( $this.hasClass( 'is-active' ) ) {

          // Add the correct ARIA attributes to the accordion label.
          $this.attr( 'aria-expanded', 'true' );

          // Show the accordion content.
          $contentElement = $(settings.targetContent).parent();

          if ( b_IsCSSMode ) {

            // Using CSS animations.
            $contentElement
              .css({
                'max-height': $contentElement.children().eq(0).outerHeight(),
                'visibility': 'visible'
                })
              .attr( 'aria-hidden', 'false' );
          } else {

            // Using JS animations.
            $contentElement
              .css({
                'height': 'auto',
                'visibility': 'visible'
              })
              .attr( 'aria-hidden', 'false' );
          }
        }
      } else {

        // Iterate over each accordion
        $this.each(function() {

          if ( $(this).hasClass( 'is-active' ) ) {

            // Remove the active class from the accordion parent.
            $(this).removeClass( 'is-active' );

            // And add it to the accordion label, along with the correct ARIA attributes.
            $(this)
              .children()
              .eq(0)
              .addClass( 'is-active' )
              .attr({
                'aria-selected': 'true',
                'aria-expanded': 'true',
                'tabindex': '0'
              });

            // Show the accordion content.
            $contentElement = $(this).children().eq(1);

            if ( b_IsCSSMode ) {

              // Using CSS animations.
              $contentElement
                .css({
                  'max-height': $contentElement.children().eq(0).outerHeight(),
                  'visibility': 'visible'
                  })
                .attr( 'aria-hidden', 'false' );
            } else {

              // Using JS animations.
              $contentElement
                .css({
                  'height': 'auto',
                  'visibility': 'visible'
                })
                .attr( 'aria-hidden', 'false' );
            }
          }

        });
      }

    }

    /**
     * Accordion setup complete, add the 'accordion-initialised' class.
     */
    function onInitComplete() {

      if ( b_IsManualMode ) {

        // Accordion is manually defined.
        $this.addClass( 'accordion-initialised' );
        $(settings.targetContent).addClass( 'is-initialised' );
      } else {

        // Iterate over each accordion
        $this.each(function() {
          $(this).addClass( 'accordion-initialised' );
        });
      }
    }

    /**
     * Utility function:
     * Generate a random integer from a range
     *
     * @param {Integer} min The minimum value (included)
     * @param {Integer} max The maximum value (Excluded)
     * @returns A Random Integer
     */
    function getRandomInt(min, max) {
      min = 1;
      max = 900000;
      return Math.floor(Math.random() * (max - min)) + min;
    }

    return this;
  };

}( $ ));